import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PublicServicesPreview = () => {
  const services = [
    {
      id: 1,
      name: "ยื่นเรื่องร้องเรียน",
      description: "ร้องเรียนปัญหาหรือข้อเสนอแนะต่อที่ทำการปกครองอำเภอเทิง",
      icon: "MessageSquare",
      color: "text-error",
      bgColor: "bg-error/10",
      link: "/complaint-submission",
      status: "เปิดให้บริการ"
    },
    {
      id: 2,
      name: "ขอเอกสารทางราชการ",
      description: "ขอหนังสือรับรอง ใบอนุญาต และเอกสารต่างๆ",
      icon: "FileText",
      color: "text-primary",
      bgColor: "bg-primary/10",
      link: "/public-services-portal",
      status: "เปิดให้บริการ"
    },
    {
      id: 3,
      name: "ลงทะเบียนกิจกรรม",
      description: "ลงทะเบียนเข้าร่วมกิจกรรมและโครงการของอำเภอเทิง",
      icon: "Calendar",
      color: "text-secondary",
      bgColor: "bg-secondary/10",
      link: "/public-services-portal",
      status: "เปิดให้บริการ"
    },
    {
      id: 4,
      name: "ติดต่อหน่วยงาน",
      description: "ข้อมูลการติดต่อและที่อยู่หน่วยงานต่างๆ",
      icon: "Phone",
      color: "text-accent",
      bgColor: "bg-accent/10",
      link: "/organization-structure",
      status: "เปิดให้บริการ"
    }
  ];

  const quickLinks = [
    {
      id: 1,
      title: "เวลาทำการ",
      content: "จันทร์-ศุกร์ 08:30-16:30 น.",
      icon: "Clock"
    },
    {
      id: 2,
      title: "โทรศัพท์",
      content: "053-795-345",
      icon: "Phone"
    },
    {
      id: 3,
      title: "อีเมล",
      content: "districtthoeng@gmail.com",
      icon: "Mail"
    },
    {
      id: 4,
      title: "ที่อยู่",
      content: "25 ถ.พิศาล ตำบลเทิง อำเภอเทิง จังหวัดเชียงราย 57160",
      icon: "MapPin"
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-4">
            บริการประชาชน
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            บริการออนไลน์และช่องทางการติดต่อสำนักงานอำเภอเทิง
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {services?.map((service) => (
            <Link
              key={service?.id}
              to={service?.link}
              className="group bg-card rounded-lg p-6 shadow-government hover:shadow-government-lg transition-government"
            >
              <div className="text-center">
                <div className={`w-16 h-16 mx-auto mb-4 rounded-lg ${service?.bgColor} flex items-center justify-center group-hover:scale-110 transition-government`}>
                  <Icon name={service?.icon} size={32} className={service?.color} />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-government">
                  {service?.name}
                </h3>
                <p className="text-sm text-muted-foreground mb-3 leading-relaxed">
                  {service?.description}
                </p>
                <span className="inline-flex items-center text-xs font-medium text-success">
                  <div className="w-2 h-2 bg-success rounded-full mr-2"></div>
                  {service?.status}
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Quick Contact Info */}
        <div className="bg-muted/50 rounded-lg p-6 lg:p-8">
          <h3 className="text-xl font-semibold text-foreground mb-6 text-center">
            ข้อมูลการติดต่อ
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {quickLinks?.map((link) => (
              <div key={link?.id} className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={link?.icon} size={20} className="text-primary" />
                </div>
                <div>
                  <h4 className="text-sm font-medium text-foreground mb-1">
                    {link?.title}
                  </h4>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {link?.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-primary to-secondary rounded-lg p-8 text-white">
            <h3 className="text-xl lg:text-2xl font-bold mb-4">
              ต้องการความช่วยเหลือ?
            </h3>
            <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto">
              ทีมงานของเราพร้อมให้บริการและตอบข้อสงสัยของท่าน
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="secondary"
                iconName="MessageSquare"
                iconPosition="left"
                asChild
              >
                <Link to="/complaint-submission">
                  ยื่นเรื่องร้องเรียน
                </Link>
              </Button>
              <Button
                variant="outline"
                iconName="ExternalLink"
                iconPosition="right"
                asChild
              >
                <Link to="/public-services-portal">
                  ดูบริการทั้งหมด
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicServicesPreview;